import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { useTranslation } from "../i18n";
import ZoneStorageSettingsPalletList from "./zone-storage-settings-pallet-list";

type palletType = {
    Zone: string;
    PalletId: string;
    Collected: boolean;
}

type batchDataType = {
    batch: number;
    totalItems: number;
    totalScannedItems: number;
    totalPallets?: number;
    collectedPallets?: number;
    pallets?: palletType[];
}[]

const ZoneStorageSettingsBatchData = ({ sorter, activeBatch, activeDate, selectedDate, batchData, changeDateFunc, reloadBatch }:
    { sorter: number, activeBatch: number, activeDate: string, selectedDate: string, batchData: batchDataType, changeDateFunc: (date: string, sorter: number) => void, reloadBatch: (date: string, sorter: number) => Promise<void> }) => {

    const { t } = useTranslation();

    const [palletPopupBatch, set_palletPopupBatch] = useState<number | null>(null);

    // Derive from batchData rather than storing the pallets at click time,
    // so a refresh while the popup is open shows the updated list.
    const palletPopupData = palletPopupBatch !== null ? batchData.find(data => data.batch === palletPopupBatch) : undefined;

    return (
        <div className="zs-card">
            <div className="flex-apart" style={{ marginBottom: 8 }}>
                <h2 className="zs-card-title" style={{ margin: 0 }}>{t("sorter_batch_info", { sorter: String(sorter) })}</h2>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <input type="date" className="zs-input" style={{ width: "auto", height: 36, fontSize: "0.8rem" }} value={selectedDate} onChange={(e) => changeDateFunc(e.target.value, sorter)} />
                    <RefreshCw className="refresh-button" onClick={() => reloadBatch(selectedDate, sorter)} />
                </div>
            </div>

            <div className="zs-batch-grid">
                {batchData.length > 0 ? batchData.map((data, index) => {
                    const pct = data.totalItems > 0 ? Math.round((data.totalScannedItems / data.totalItems) * 100) : 0;
                    const isActive = selectedDate === activeDate && data.batch === activeBatch;
                    return (
                        <div key={index} className={`zs-batch-card ${isActive ? "active" : ""}`}>
                            <span className="zs-batch-number">{data.batch}</span>
                            <div className="zs-batch-progress">
                                <div className="zs-batch-progress-bar" style={{ width: `${pct}%` }} />
                            </div>
                            <span className="zs-batch-pct">{pct}%</span>
                            <span className="zs-batch-detail">{data.totalScannedItems}/{data.totalItems}</span>
                            {data.totalPallets !== undefined &&
                                <span className="zs-batch-pallets" role="button" onClick={() => set_palletPopupBatch(data.batch)}>{t("pallets_scanned_of_total", { scanned: String(data.collectedPallets ?? 0), total: String(data.totalPallets) })}</span>}
                        </div>
                    );
                }) : <p style={{ color: "var(--color-text-muted)", textAlign: "center", width: "100%" }}>{t("no_data")}</p>}
            </div>

            {palletPopupData && <ZoneStorageSettingsPalletList batch={palletPopupData.batch} pallets={palletPopupData.pallets ?? []} onClose={() => set_palletPopupBatch(null)} />}
        </div>
    );
}

export default ZoneStorageSettingsBatchData;
